const imageContainers = document.querySelectorAll('.image-container');
imageContainers.forEach((container) => {
  const secondaryImage = container.querySelector('.secondary-image');
  container.addEventListener('mouseenter', () => {
    secondaryImage.style.display = 'block'; // or secondaryImage.style.opacity = 1;
  });
  container.addEventListener('mouseleave', () => {
    secondaryImage.style.display = 'none'; // or secondaryImage.style.opacity = 0;
  });
});